export const letterAndNumberRegExp = /[а-яА-Я]+\d+/m;
export const letterRegExp = /[а-яА-Я]+/m;
export const groupNumberRegExp = /\d+/m;
export const classLetterAndNumberRegExp = /[а-яА-Я]+\d+/m;
export const alphabet = ['Н', 'М', 'Л', 'У'];
